import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "dailyFields",
    "weeklyFields",
    "yearlyFields",
    "yearlyDayOfMonthFields",
    "yearlyDayOfWeekFields"
  ]

  connect() {
    this.updateFields()
  }

  scheduleTypeChanged(event) {
    this.updateFields()
  }

  yearlyDayTypeChanged(event) {
    const dayType = event.target.value
    const everyMonthCheckbox = this.element.querySelector('input[type="checkbox"][name="timeslot[months][]"][value="all"]')

    if (dayType === "day_of_month") {
      this.yearlyDayOfMonthFieldsTargets.forEach((el) => el.classList.remove("hidden"))
      this.yearlyDayOfWeekFieldsTargets.forEach((el) => el.classList.add("hidden"))
      // Re-enable "Every month" checkbox
      if (everyMonthCheckbox) {
        everyMonthCheckbox.disabled = false
      }
    } else {
      this.yearlyDayOfMonthFieldsTargets.forEach((el) => el.classList.add("hidden"))
      this.yearlyDayOfWeekFieldsTargets.forEach((el) => el.classList.remove("hidden"))
      // Disable "Every month" checkbox and uncheck it if checked
      if (everyMonthCheckbox) {
        if (everyMonthCheckbox.checked) {
          everyMonthCheckbox.checked = false
          // Uncheck all month checkboxes and re-enable them
          const monthCheckboxes = this.element.querySelectorAll('input[type="checkbox"][name="timeslot[months][]"]:not([value="all"])')
          monthCheckboxes.forEach((checkbox) => {
            checkbox.checked = false
            checkbox.disabled = false
          })
        }
        everyMonthCheckbox.disabled = true
      }
    }
  }

  everyMonthChanged(event) {
    const isChecked = event.target.checked
    const monthCheckboxes = Array.from(this.element.querySelectorAll('input[type="checkbox"][name="timeslot[months][]"]:not([value="all"])'))

    if (isChecked) {
      // When checking "Every month", store previous selection and check/disable all month checkboxes
      const previousSelection = monthCheckboxes
        .filter(cb => cb.checked && !cb.disabled)
        .map(cb => cb.value)
      this.element.dataset.previousMonthSelection = previousSelection.join(',')

      monthCheckboxes.forEach((checkbox) => {
        checkbox.checked = true
        checkbox.disabled = true
      })
    } else {
      // When unchecking "Every month", restore previous selection
      const previousSelection = this.element.dataset.previousMonthSelection
        ? this.element.dataset.previousMonthSelection.split(',')
        : []

      monthCheckboxes.forEach((checkbox) => {
        checkbox.disabled = false
        // Restore to previous selection if it exists, otherwise uncheck
        checkbox.checked = previousSelection.includes(checkbox.value)
      })

      // Clear stored selection
      delete this.element.dataset.previousMonthSelection
    }
  }

  everyDayChanged(event) {
    const isChecked = event.target.checked
    const dayCheckboxes = Array.from(this.element.querySelectorAll('input[type="checkbox"][name="timeslot[days][]"]:not([value="all"])'))

    if (isChecked) {
      // When checking "Every day", store previous selection and check/disable all day checkboxes
      const previousSelection = dayCheckboxes
        .filter(cb => cb.checked && !cb.disabled)
        .map(cb => cb.value)
      this.element.dataset.previousDaySelection = previousSelection.join(',')

      dayCheckboxes.forEach((checkbox) => {
        checkbox.checked = true
        checkbox.disabled = true
      })
    } else {
      // When unchecking "Every day", restore previous selection
      const previousSelection = this.element.dataset.previousDaySelection
        ? this.element.dataset.previousDaySelection.split(',')
        : []

      dayCheckboxes.forEach((checkbox) => {
        checkbox.disabled = false
        // Restore to previous selection if it exists, otherwise uncheck
        checkbox.checked = previousSelection.includes(checkbox.value)
      })

      // Clear stored selection
      delete this.element.dataset.previousDaySelection
    }
  }

  updateFields() {
    const scheduleType = this.element.querySelector('[name="timeslot[schedule_type]"]:checked, [name="schedule[schedule_type]"]:checked')?.value ||
                         this.element.querySelector('[name="timeslot[schedule_type]"], [name="schedule[schedule_type]"]')?.value ||
                         "daily"

    // Hide all fields
    this.dailyFieldsTargets.forEach((el) => el.classList.add("hidden"))
    this.weeklyFieldsTargets.forEach((el) => el.classList.add("hidden"))
    this.yearlyFieldsTargets.forEach((el) => el.classList.add("hidden"))

    // Show relevant fields
    switch (scheduleType) {
      case "daily":
        this.dailyFieldsTargets.forEach((el) => el.classList.remove("hidden"))
        break
      case "weekly":
        this.weeklyFieldsTargets.forEach((el) => el.classList.remove("hidden"))
        break
      case "yearly":
        this.yearlyFieldsTargets.forEach((el) => el.classList.remove("hidden"))
        // Also handle yearly day type
        const dayType = this.element.querySelector('[name="timeslot[day_type]"]')?.value || "day_of_month"
        this.yearlyDayTypeChanged({ target: { value: dayType } })
        // Ensure "Every month" checkbox state is correct based on day type
        const everyMonthCheckbox = this.element.querySelector('input[type="checkbox"][name="timeslot[months][]"][value="all"]')
        if (everyMonthCheckbox && dayType === "day_of_week") {
          everyMonthCheckbox.disabled = true
          if (everyMonthCheckbox.checked) {
            everyMonthCheckbox.checked = false
          }
        }
        break
    }
  }
}

